import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Typography } from '@mui/material';
import { useMemo, useRef } from 'react';
import { TypeBySignal } from '../../factories/ContextQuery/QueryParamSelectors/typeBySignal';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const typeBySignalWidget = () => {
    const lastQueryParamsRef = useRef(undefined);
    const component = useMemo(() => (_jsxs(Stack, { gap: 1, children: [_jsx(Typography, { variant: "h5", children: "TypeBySignal" }), _jsx(TypeBySignal, { type: '', updateParams: () => { }, index: 0, children: undefined, selected: false, keyPress: () => { }, lastQueryParamsRef: lastQueryParamsRef, lastQuery: undefined, clearSelectedObjects: () => { } })] })), []);
    return {
        name: 'typeBySignal',
        category: 'composite',
        component,
    };
};
